import React from 'react';
import styled from 'styled-components';
import { getUserStatus } from '../../helpers/TimeUtils';
import { useTranslation } from 'react-i18next';

const StatusContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: ${props => props.size === 'small' ? '12px' : '14px'};
  color: ${props => props.color || '#6b7280'};
`;

const StatusDot = styled.div`
  width: ${props => props.size === 'small' ? '6px' : '8px'};
  height: ${props => props.size === 'small' ? '6px' : '8px'};
  border-radius: 50%;
  background-color: ${props => props.color};
  ${props => props.animate && `
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.5;
      }
    }
  `}
`;

const StatusText = styled.span`
  font-weight: ${props => props.bold ? '500' : '400'};
`;

const OnlineStatus = ({ isOnline, lastSeen, size = 'normal', showText = true, showDot = true, className }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'es';
  
  const status = getUserStatus(isOnline, lastSeen, lang);

  if (!showText && !showDot) {
    return null;
  }

  return (
    <StatusContainer size={size} color={status.color} className={className}>
      {showDot && status.dot && (
        <StatusDot 
          size={size} 
          color={status.color}
          animate={status.status === 'online'}
        />
      )}
      {showText && (
        <StatusText bold={status.status === 'online'}>
          {status.text}
        </StatusText>
      )}
    </StatusContainer>
  );
};

export default OnlineStatus;
